/* Global imports. */
import React from "react";
import { Link } from "gatsby"
import { nanoid } from 'nanoid';

interface Props {
  bannerType?: string;
  title: string;
  text: string;
  buttonText: string;
  buttonUrl: string;
  imageUrl: string;
  imagePlacement?: string;
  textPlacementClass?: string;
  primaryTextColour?: string;
  backgroundColour?: string;
  componentID?: string;
  referringSlug?: string;
  bannerCollectionLength?: number;
}

function BannerSimple({bannerType, title, text, buttonText, buttonUrl, imageUrl, imagePlacement, textPlacementClass, primaryTextColour, backgroundColour, componentID, referringSlug, bannerCollectionLength}: Props) {
  const bannerTypeBackgroundImage = "background_image"
  const bannerBackgroundImageStyle = {
    backgroundImage: bannerType === bannerTypeBackgroundImage || bannerType === undefined ? `url(${imageUrl})` : "none",
    backgroundColor: `${backgroundColour}`,
  }

  const textStyle = {
    color: primaryTextColour
  }

  let textAlignClass = "";

  switch(textPlacementClass) {
    case "banner_text_left":
      textAlignClass = "text-left";
      break;
    case "banner_text_centered":
      textAlignClass = "text-center";
      break;
    case "banner_text_right":
      textAlignClass = "text-right";      
      break;
    default:
      textAlignClass = "text-center";
  }

  const maxTextWidthClass = textPlacementClass === "banner_text_centered" ? "sm:max-w-full" : "sm:max-w-[525px]"

  return <div id={componentID} key={nanoid()} className={`${bannerCollectionLength > 1 ? `w-full` : `col-span-6`} flex flex-col justify-center min-h-[360px] pt-[35%] pb-1 sm:pb-0 sm:pt-0 bg-top bg-no-repeat bg-contain sm:bg-cover rounded-md shadow-card sm:rounded-none mb-8`} style={bannerBackgroundImageStyle}>
      <div className="mx-auto sm:mx-0 sm:px-8">
      <section className={`ml-auto mr-auto flex-wrap over relative w-full`} >
        <div className="relative">
          <div className="relative z-10 grid w-full mb-6 sm:mt-6 sm:w-[100%]">
            <div className={`flex flex-wrap h-full p-6 text-left sm:p-2 ${textPlacementClass === "banner_text_right" ? "sm:items-end" : "sm:items-start"} sm:justify-center sm:flex-none sm:flex-col ${textAlignClass}`}>
              <span className={maxTextWidthClass}>
              <h1 className="w-full mx-0 mb-3 mr-0 text-2xl text-black md:mb-6 sm:text-5xl sm:text-white" style={textStyle} >{title}</h1>
              <p className={`mb-6 text-base text-black sm:text-white ${textAlignClass} `} style={textStyle} dangerouslySetInnerHTML={{ __html: text }}/>
              {buttonUrl && buttonText && 
                <p><Link data-title={title} data-ref-slug={referringSlug} data-component="banner" data-component-id={componentID} to={`${buttonUrl}`} className="ml-0 button md:!border-0 inline-block">{buttonText}</Link></p>
              }
              </span>
            </div>     
          </div>
        </div>
        </section>
      </div>
  </div>
}

export default BannerSimple;